<template>
  <div class='EnbWhatsapp'>
    <button @click="push" v-if="!load">
      <whats-icon tam="30px"/>
      Enviar pedido
    </button>
    <component
    :is="Prefes.spinner.tipo"
    :color="Prefes.spinner.cor"
    :size="Prefes.spinner.tipo === 'EnbSyncLoader' ? '12px' : '40px'"
    style="z-index: 999"
    v-if="load"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import WhatsIcon from '@/components/Theme03/Icons/WhatsIcon'
import MsgWhats from './MsgWhats'
import { loaders } from '@/components/Spinner'
export default {
  name: 'EnbWhatsapp',
  components: { WhatsIcon, ...loaders },
  props: ['validate'],
  data () {
    return {
      load: false
    }
  },
  computed: {
    ...mapGetters(['Profile', 'CheckoutItens01', 'CheckoutTotal01', 'SelectedClientEdit', 'Empresa', 'Prefes', 'cupom', 'Frete', 'NotasPedido', 'ValorFrete'])
  },
  methods: {
    ...mapActions(['setClientValidate', 'PushPedido', 'SetPedidoAtual', 'PushClient', 'GetGiftStore']),
    async push () {
      let valid = await this.validate.$validate()
      if(!valid && !Object.keys(this.Profile).length) {
        this.setClientValidate(this.validate)
        return
      }
      this.load = true
      let freteValorMin = parseFloat(this.Frete.valormin.replace('R$', '').replace(',', '.'))
      //usuario já logado, apenas criar o pedido e encaminhando para o whatsapp
      if(Object.keys(this.Profile).length) {
        this.PushPedido({ dateCreate: new Date(), usuario: this.SelectedClientEdit.usuario, itens: this.CheckoutItens01, frete: freteValorMin > this.CheckoutTotal01 ? 0 : this.ValorFrete, notas: this.NotasPedido })
        .then(async pedido => {
          let gift = await this.GetGiftStore({ codigo: this.cupom.codigo, usuario: this.SelectedClientEdit.usuario, itens: this.CheckoutItens01, pedidoid: pedido.id })
            .then(res => res)
          pedido.gift = gift.codigo
          pedido.giftvalor = gift.valor  
          pedido.valorTotal = pedido.valorTotal - gift.valor 
          // setando o pedido atual
          this.SetPedidoAtual([pedido])
          //encaminhando para whatsapp
          window.location.replace(`https://wa.me/55${this.Empresa.whatsapp}?text=${MsgWhats(pedido)}`)
        })
        return
      }
      //Criando o usuario, o pedido e encaminhando para o whatsapp
      //Criando usuário
      this.PushClient(this.SelectedClientEdit)
        // criando o pedido
        .then(client => this.PushPedido({ dateCreate: new Date(), usuario: client, itens: this.CheckoutItens01, frete: freteValorMin > this.CheckoutTotal01 ? 0 : this.ValorFrete, notas: this.NotasPedido }))
        .then(async pedido => {
          let gift = await this.GetGiftStore({ codigo: this.cupom.codigo, usuario: this.SelectedClientEdit.usuario, itens: this.CheckoutItens01, pedidoid: pedido.id })
            .then(res => res)
          pedido.gift = gift.codigo
          pedido.giftvalor = gift.valor  
          pedido.valorTotal = pedido.valorTotal - gift.valor
          // setando o pedido atual
          this.SetPedidoAtual([pedido])
          //encaminhando para whatsapp
          window.location.replace(`https://wa.me/55${this.Empresa.whatsapp}?text=${MsgWhats(pedido)}`)
        })
    }
  }
}
</script>

<style scoped>
.EnbWhatsapp {
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 5%;
}

button {
  border: 0;
  width: 50%;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  border-radius: 8px;
  color: #FFFFFF;
  cursor: pointer;
  background-color: #67c15e;
  border: thin solid #13620A;
  font-weight: bold;
}
</style>
